/**
 * @file   src\components\GitchaAvailableLocationsScreen.js
 * @brief  This file is responsible for showing gitcha available locations in home page
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useEffect, useState } from "react";
import {
  getGeoLocation,
  getGitchaAvailableStates,
} from "../services/commonServices";
import { toTitleCase, setLocalStorage } from "../helpers/common";
import RequestGitchaAvailability from "../components/Common/RequestGitchaAvailability";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch } from "react-redux";
import { fetchGitchaAvailableCities } from "../actions/locations";
import { useSelector } from "react-redux";
import { getLocalStorage } from "../helpers/common";

const GitchaAvailableLocations = (props) => {
  const browserLocation = getLocalStorage("userLocation");
  const [availableStates, setAvailableStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [showGitchaNotAvailablePopup, setShowGitchaNotAvailablePopup] =
    useState(true);
  const [gitchaNotAvailableLocation, setGitchaNotAvailableLocation] =
    useState(null);
  const availableCities = useSelector(
    (state) => state.locations.availableCities
  );

  const dispatch = useDispatch();
  useEffect(() => {
    fetchGitchaAvailableStates();
  }, []);

  useEffect(() => {
    setGitchaNotAvailableLocation(props.userLocation);
    setShowGitchaNotAvailablePopup(true);
  }, [props.userLocation]);

  const fetchGitchaAvailableStates = async () => {
    await getGitchaAvailableStates()
      .then((response) => {
        const res = _.get(response, "result", []);
        setAvailableStates(res);
        res.map((item) => handleLocationState(item.StateCode));
      })
      .catch((error) => console.log(error));
  };

  const handleLocationSelect = async (city, state) => {
    const reqPayload = `address=${city},${state}`;
    await getGeoLocation(reqPayload).then((data) => {
      const results = _.get(data, "results");
      if (results?.length > 0) {
        const address = results[0];
        const geometry = _.get(address, "geometry", "");
        const locBounds = _.get(geometry, "location", "");
        const lat = _.get(locBounds, "lat", "");
        const long = _.get(locBounds, "lng", "");
        setLocalStorage("searchedLocation", {
          latitude: lat,
          longitude: long,
          city: city,
          state: state,
          formatted_address: toTitleCase(city) + ", " + toTitleCase(state),
          isFromAvailableCities: true,
        });
        props.setUserLocation({
          latitude: lat,
          longitude: long,
          city: city,
          state: state,
          formatted_address: toTitleCase(city) + ", " + toTitleCase(state),
          isFromAvailableCities: true,
        });
      }
    });
  };

  const handleLocationState = (stateCode) => {
    if (stateCode) {
      const stateCodeSelected = selectedStates.indexOf(stateCode);
      if (stateCodeSelected == -1) {
        setSelectedStates([...selectedStates, stateCode]);
        dispatch(fetchGitchaAvailableCities({ state: stateCode }));
      }
    }
  };

  const loadCities = (stateCode) => {
    const selectedState = availableCities?.find(
      (cities) => cities.state === stateCode
    );
    const cities = selectedState?.cities;

    return (
      cities &&
      cities.length > 0 &&
      cities.map((loc, index) => (
        <a href="#" onClick={() => handleLocationSelect(loc.City, stateCode)}>
          {toTitleCase(loc.City)}, {toTitleCase(stateCode)}
        </a>
      ))
    );
  };
  return (
    <>
      <h3>Gitcha isn’t operating in this area (yet!)</h3>
      <p>
        We’re coming to your area soon. Here are the areas we’re currently
        operating in:
      </p>
      <ul className="operating-areas-list">
        {availableStates?.length > 0 &&
          availableStates.map((loc, index) => (
            <li key={index}>
              <a href="#">{loc.State}</a>
              <ul>{loadCities(loc.StateCode)}</ul>
            </li>
          ))}
      </ul>

      {showGitchaNotAvailablePopup && (
        <RequestGitchaAvailability
          show={showGitchaNotAvailablePopup}
          locationFromSTorage={
            gitchaNotAvailableLocation
              ? gitchaNotAvailableLocation
              : browserLocation
          }
          onHide={() => {
            setShowGitchaNotAvailablePopup(false);
            setGitchaNotAvailableLocation(null);
          }}
        />
      )}
    </>
  );
};

export default GitchaAvailableLocations;
